import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, unref as _unref, createCommentVNode as _createCommentVNode, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-936f241c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rotationChart" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rotationChart_title" }, "轮播模式", -1))
const _hoisted_3 = { class: "rotationChart_type" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "rotationChart_tab" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "rotationChart_tab_line" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "modular_top_add"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modular_top_text" }, "添加图片：最多添加6个，可拖拽排序", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modular_top_text" }, "建议高度：1920px*1080px", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modular_top_text" }, "建议大小：3M", -1))
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "rotationChart_modular_bottom" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 2,
  class: "rotationChart_style"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rotationChart_title rotationChart_style_title" }, "轮播样式", -1))
const _hoisted_18 = { class: "rotationChart_style_indicator" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "indicator_every_line" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "indicator_every_lines" }, null, -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rotationChart_title rotationChart_style_title" }, [
  /*#__PURE__*/_createTextVNode(" 轮播间隔 "),
  /*#__PURE__*/_createElementVNode("div", { class: "title_tips" }, "(建议最小3s，最大7s）")
], -1))
const _hoisted_24 = { class: "rotationChart_style_indicator" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "indicator_every_tips" }
const _hoisted_27 = { class: "contentModal" }
const _hoisted_28 = { class: "contentModal_title" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "contentModal_title_text" }, "文字内容：", -1))
const _hoisted_30 = { class: "contentModal_content" }
const _hoisted_31 = { class: "contentModal_content_line" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line_title" }, "主标题：", -1))
const _hoisted_33 = { class: "line_right" }
const _hoisted_34 = { class: "input_length" }
const _hoisted_35 = { class: "line_right_color" }
const _hoisted_36 = { class: "contentModal_content_line" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line_title" }, "副标题：", -1))
const _hoisted_38 = { class: "line_right" }
const _hoisted_39 = { class: "input_length" }
const _hoisted_40 = { class: "line_right_color" }
const _hoisted_41 = { class: "contentModal_content_line" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line_title" }, "简介：", -1))
const _hoisted_43 = { class: "line_right" }
const _hoisted_44 = { class: "input_length" }
const _hoisted_45 = { class: "line_right_color" }
const _hoisted_46 = { class: "contentModal_title" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "contentModal_title_text" }, "按钮显示：", -1))
const _hoisted_48 = { class: "contentModal_content" }
const _hoisted_49 = { class: "contentModal_content_line" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line_title" }, "颜色：", -1))
const _hoisted_51 = { class: "line_right" }
const _hoisted_52 = { class: "line_right_see" }
const _hoisted_53 = { class: "line_right_color" }
const _hoisted_54 = { class: "contentModal_content_line" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line_title" }, "名称：", -1))
const _hoisted_56 = { class: "line_right" }
const _hoisted_57 = { class: "input_length" }
const _hoisted_58 = { class: "line_right_color" }
const _hoisted_59 = { class: "contentModal_title" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "contentModal_title_text" }, "跳转链接：", -1))
const _hoisted_61 = { class: "contentModal_content" }
const _hoisted_62 = { class: "contentModal_content_line" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line_title" }, "链接方式：", -1))
const _hoisted_64 = {
  key: 0,
  class: "contentModal_content_line"
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line_title" }, "页面：", -1))
const _hoisted_66 = {
  key: 1,
  class: "contentModal_content_line"
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line_title" }, "内容：", -1))
const _hoisted_68 = {
  key: 2,
  class: "contentModal_content_line"
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line_title" }, "外链：", -1))
const _hoisted_70 = { class: "contentModal_title" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "contentModal_title_text" }, "定时发布：", -1))
const _hoisted_72 = { class: "contentModal_content" }
const _hoisted_73 = { class: "contentModal_content_line" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line_title" }, "上线时间：", -1))
const _hoisted_75 = { class: "contentModal_content_line" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line_title" }, "持续时间：", -1))
const _hoisted_77 = {
  key: 0,
  class: "contentModal_content_line"
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line_title" }, null, -1))

import { ref, watch } from 'vue';
import Draggable from 'vuedraggable';
import emitter from '@/utils/mitt';
import { InputNumber, Modal, Radio, Input, Upload, message } from 'ant-design-vue';
import { LoadingOutlined } from '@ant-design/icons-vue';
import moment, { Moment } from 'moment';
import { ElColorPicker } from 'element-plus';
import { getToken } from '@/plugins/cookie';
import { colorList, uploadNow } from './PublicFunction';
import http from '@/api/conentCenter/communal';
import { useRoute } from 'vue-router';
import { dragDrop } from '@/utils/format/dragDrop';


export default /*#__PURE__*/_defineComponent({
  __name: 'RotationChart_setup',
  props: {
  custom: {},
  labelId: {},
},
  setup(__props) {

const props: any = __props;

const route = useRoute();
const gatewayId = route.params.gatewayId;
const aModal = Modal;
const aRadioGroup = Radio.Group;
const aInputNumber = InputNumber;
const aTextarea = Input.TextArea;
const aUpload = Upload;
const token = getToken();
const rotationChartList: any = ref([]);

props.custom.rotationChartList.length > 0 ? (rotationChartList.value = [...props.custom.rotationChartList]) : '';
const rotationChart = ref();
rotationChart.value = { ...props.custom.rotationChart };

const toVisualization = () => {
  const custom = { ...props.custom };
  custom.rotationChartList = [...rotationChartList.value];
  custom.rotationChart = { ...rotationChart.value };
  emitter.emit('visualization', custom);
};

const getType = (index: number) => {
  rotationChart.value.type = index;
  toVisualization();
};

const setUp = ref(0);
const getSetUp = (id: number) => {
  setUp.value = id;
};

const choiceOptions = ref([
  {
    value: 0,
    label: '站内页面',
  },
  {
    value: 1,
    label: '外部链接',
  },
]);
const timeOptions = ref([
  {
    value: 0,
    label: '永久',
  },
  {
    value: 1,
    label: '自定义',
  },
]);
const contentSet = ref({
  content: false,
  title: '',
  titleColor: '#16B9FA',
  subtitle: '',
  subtitleColor: '#16B9FA',
  profiles: '',
  profilesColor: '#FFFFFF',
  btn: false,
  btnColor: '#16B9FA',
  btnName: '',
  btnNameColor: '#16B9FA',
  link: false,
  jump: 0, //0站内，1站外
  insideLink: undefined,
  inSpecificLink: undefined,
  outsideLink: '',
  timing: false,
  timeChoice: 0,
  startTime: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
  endTime: moment(new Date(new Date().valueOf() + 1 * 24 * 60 * 60 * 1000)).format('YYYY-MM-DD HH:mm:ss'),
});
const pageOptions = ref([
  { value: 1, label: '文章' },
  { value: 2, label: '图片' },
  { value: 3, label: '直播' },
  { value: 4, label: '文档' },
  { value: 5, label: '文章分类' },
  { value: 6, label: '图片分类' },
  { value: 7, label: '直播分类' },
  { value: 8, label: '文档分类' },
]);
const sitePageLinks = ref();
const getInsideLink = () => {
  contentSet.value.inSpecificLink = undefined;
  getSitePageLinks();
};
const getSitePageLinks = () => {
  const data = {
    portal_id: gatewayId,
    type: contentSet.value.insideLink || 1,
  };
  http.getSitePageLinks({ params: data }).then((res) => {
    sitePageLinks.value = [...res.data.data];
  });
};

// 轮播模式
const getPattern = (index: number) => {
  rotationChart.value.indicatorType = index;
  toVisualization();
};

// 轮播间隔
const interval = ref(0);
const inputNumber = ref(5);
const getInterval = (index: number) => {
  interval.value = index;
  const number = index == 0 ? 3 : index == 1 ? 7 : inputNumber.value;
  rotationChart.value.interval = number * 1000;
  toVisualization();
};

// 链接设置
const setIndex = ref();
const openModal = (res: any, index: any) => {
  setIndex.value = index;
  contentModal.value = true;
  contentSet.value = res.jump;
  getSitePageLinks();
};

const disabledDate = (current: Moment) => {
  return current < moment().endOf('day').subtract(1, 'days');
};

// 文本设置
const contentModal = ref(false);

// 文本内容设置确定
const setContent = () => {
  rotationChartList.value[setIndex.value].jump = contentSet.value;
  contentModal.value = false;
  toVisualization();
};

const addList = (type: number) => {
  const data = {
    id: rotationChartList.value.length - 1,
    img: '',
    imgId: 0,
    type: type,
    jump: contentSet.value,
  };
  rotationChartList.value.push(data);
  toVisualization();
};

// 立即上传
const { fileList, flieLink, loading, beforeUpload, handleChange } = uploadNow();
watch(
  () => flieLink.value,
  () => {
    rotationChartList.value[setIndex.value].img = flieLink.value;
    toVisualization();
  }
);
watch(
  () => loading.value,
  () => {
    rotationChartList.value[setIndex.value].loading = loading.value;
  }
);

const delImg = (index: number) => {
  if (rotationChartList.value.length == 1) {
    message.destroy();
    message.info('最少保留一个轮播图');
  } else {
    rotationChartList.value.splice(index, 1);
    toVisualization();
  }
};

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (item, index) => {
          return _createElementVNode("div", {
            key: item,
            class: _normalizeClass([rotationChart.value.type == index ? 'type_btn_click' : '', "type_btn"]),
            onClick: ($event: any) => (getType(index))
          }, [
            _createVNode(_component_svg_icon, {
              "icon-class": index == 0 ? 'rotationChart_type' : 'rotationChart_type_card'
            }, null, 8, ["icon-class"])
          ], 10, _hoisted_4)
        }), 64))
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (item, index) => {
          return _createElementVNode("div", {
            key: index,
            class: _normalizeClass(["rotationChart_tab_name", setUp.value == index ? 'tab_name_click' : '']),
            onClick: ($event: any) => (getSetUp(index))
          }, [
            _createTextVNode(_toDisplayString(index == 0 ? '内容设置' : '样式设置') + " ", 1),
            _withDirectives(_createElementVNode("div", _hoisted_7, null, 512), [
              [_vShow, setUp.value == index]
            ])
          ], 10, _hoisted_6)
        }), 64))
      ]),
      (setUp.value == 0)
        ? (_openBlock(), _createBlock(_unref(Draggable), {
            key: 0,
            list: rotationChartList.value,
            "item-key": "id",
            animation: 150,
            onDrop: _unref(dragDrop)
          }, {
            item: _withCtx(({ element, index }) => [
              _createElementVNode("div", {
                class: "rotationChart_modular",
                onClick: ($event: any) => (setIndex.value = index)
              }, [
                _createVNode(_unref(aUpload), {
                  class: "rotationChart_modular_top",
                  "file-list": _unref(fileList),
                  "onUpdate:fileList": _cache[0] || (_cache[0] = ($event: any) => (_isRef(fileList) ? (fileList).value = $event : null)),
                  name: "images",
                  multiple: false,
                  action: "/api/v1/common/upload_images",
                  "before-upload": _unref(beforeUpload),
                  headers: { token: _unref(token) },
                  onChange: _unref(handleChange)
                }, {
                  default: _withCtx(() => [
                    (!element.img && !element.loading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createVNode(_component_svg_icon, {
                            class: "uploadPhoto",
                            "icon-class": "uploadPhoto"
                          }),
                          _hoisted_10,
                          _hoisted_11,
                          _hoisted_12
                        ]))
                      : _createCommentVNode("", true),
                    (element.loading && !element.img)
                      ? (_openBlock(), _createBlock(_unref(LoadingOutlined), {
                          key: 1,
                          class: "modular_top_loading"
                        }))
                      : (element.img)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 2,
                            class: "modular_top_img",
                            src: element.img,
                            alt: ""
                          }, null, 8, _hoisted_13))
                        : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["file-list", "before-upload", "headers", "onChange"]),
                _createVNode(_component_svg_icon, {
                  class: "add_delete",
                  "icon-class": "delete_circular",
                  onClick: ($event: any) => (delImg(index))
                }, null, 8, ["onClick"]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_unref(aUpload), {
                    class: "modular_bottom_btn btn_border",
                    "file-list": _unref(fileList),
                    "onUpdate:fileList": _cache[1] || (_cache[1] = ($event: any) => (_isRef(fileList) ? (fileList).value = $event : null)),
                    name: "images",
                    multiple: false,
                    action: "/api/v1/common/upload_images",
                    "before-upload": _unref(beforeUpload),
                    headers: { token: _unref(token) },
                    onChange: _unref(handleChange)
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(element.img == '' ? '' : 'text_color')
                      }, _toDisplayString(element.img == '' ? '上传图片' : '更换图片'), 3)
                    ]),
                    _: 2
                  }, 1032, ["file-list", "before-upload", "headers", "onChange"]),
                  _createElementVNode("div", {
                    class: "modular_bottom_btn",
                    onClick: ($event: any) => (openModal(element, index))
                  }, "文字内链设置", 8, _hoisted_15)
                ])
              ], 8, _hoisted_8)
            ]),
            _: 1
          }, 8, ["list", "onDrop"]))
        : _createCommentVNode("", true),
      (setUp.value == 0)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "rotationChart_add",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (setIndex.value = rotationChartList.value.length - 1))
          }, [
            _createVNode(_unref(aUpload), {
              class: "rotationChart_add_upload",
              "file-list": _unref(fileList),
              "onUpdate:fileList": _cache[2] || (_cache[2] = ($event: any) => (_isRef(fileList) ? (fileList).value = $event : null)),
              name: "images",
              multiple: false,
              action: "/api/v1/common/upload_images",
              "before-upload": _unref(beforeUpload),
              headers: { token: _unref(token) },
              onChange: _unref(handleChange)
            }, {
              default: _withCtx(() => [
                (rotationChartList.value.length < 6)
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      class: "rotationChart_add_btn",
                      onClick: addList
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_svg_icon, { "icon-class": "increase" })
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" 图文轮播 ")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["file-list", "before-upload", "headers", "onChange"])
          ]))
        : _createCommentVNode("", true),
      (setUp.value == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (item, index) => {
                return _createElementVNode("div", {
                  class: _normalizeClass(["indicator_every", rotationChart.value.indicatorType == index ? 'indicator_every_click' : '']),
                  key: index,
                  onClick: ($event: any) => (getPattern(index))
                }, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (item) => {
                    return _withDirectives(_createElementVNode("div", {
                      key: item,
                      class: "indicator_every_dot"
                    }), [
                      [_vShow, index == 0]
                    ])
                  }), 64)),
                  _withDirectives(_createElementVNode("div", _hoisted_20, _hoisted_22, 512), [
                    [_vShow, index == 1]
                  ]),
                  _withDirectives(_createElementVNode("div", null, "1/3", 512), [
                    [_vShow, index == 2]
                  ])
                ], 10, _hoisted_19)
              }), 64))
            ]),
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (item, index) => {
                return _createElementVNode("div", {
                  class: _normalizeClass(["indicator_every", interval.value == index ? 'indicator_every_click' : '']),
                  key: index,
                  onClick: ($event: any) => (getInterval(index))
                }, [
                  _withDirectives(_createElementVNode("div", null, "3s", 512), [
                    [_vShow, index == 0]
                  ]),
                  _withDirectives(_createElementVNode("div", null, "7s", 512), [
                    [_vShow, index == 1]
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_26, "自定义", 512), [
                    [_vShow, index == 2 && interval.value !== 2]
                  ]),
                  _withDirectives(_createVNode(_unref(aInputNumber), {
                    value: inputNumber.value,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((inputNumber).value = $event)),
                    class: "indicator_every_input",
                    min: 2,
                    max: 15,
                    formatter: (value) => `${value}s`,
                    parser: (value) => value.replace('s', '')
                  }, null, 8, ["value", "formatter", "parser"]), [
                    [_vShow, index == 2 && interval.value == 2]
                  ])
                ], 10, _hoisted_25)
              }), 64))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(aModal), {
      visible: contentModal.value,
      "onUpdate:visible": _cache[25] || (_cache[25] = ($event: any) => ((contentModal).value = $event)),
      centered: "",
      title: "文字内容设置",
      width: "640px",
      onOk: setContent
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createVNode(_component_a_switch, {
              checked: contentSet.value.content,
              "onUpdate:checked": _cache[5] || (_cache[5] = ($event: any) => ((contentSet.value.content) = $event))
            }, null, 8, ["checked"])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createElementVNode("div", _hoisted_33, [
                _createVNode(_component_a_input, {
                  placeholder: "请输入主标题",
                  value: contentSet.value.title,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((contentSet.value.title) = $event)),
                  maxlength: 6
                }, {
                  suffix: _withCtx(() => [
                    _createElementVNode("div", _hoisted_34, _toDisplayString(contentSet.value.title.length) + "/ 6", 1)
                  ]),
                  _: 1
                }, 8, ["value"]),
                _createElementVNode("div", _hoisted_35, [
                  _createTextVNode(_toDisplayString(contentSet.value.titleColor) + " ", 1),
                  _createVNode(_unref(ElColorPicker), {
                    modelValue: contentSet.value.titleColor,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((contentSet.value.titleColor) = $event)),
                    predefine: _unref(colorList),
                    size: "mini"
                  }, null, 8, ["modelValue", "predefine"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _createElementVNode("div", _hoisted_38, [
                _createVNode(_component_a_input, {
                  placeholder: "请输入副标题",
                  value: contentSet.value.subtitle,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((contentSet.value.subtitle) = $event)),
                  maxlength: 6
                }, {
                  suffix: _withCtx(() => [
                    _createElementVNode("div", _hoisted_39, _toDisplayString(contentSet.value.subtitle.length) + "/ 6", 1)
                  ]),
                  _: 1
                }, 8, ["value"]),
                _createElementVNode("div", _hoisted_40, [
                  _createTextVNode(_toDisplayString(contentSet.value.subtitleColor) + " ", 1),
                  _createVNode(_unref(ElColorPicker), {
                    modelValue: contentSet.value.subtitleColor,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((contentSet.value.subtitleColor) = $event)),
                    predefine: _unref(colorList),
                    size: "mini"
                  }, null, 8, ["modelValue", "predefine"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _hoisted_42,
              _createElementVNode("div", _hoisted_43, [
                _createVNode(_component_a_input, {
                  placeholder: "请输入副标题",
                  value: contentSet.value.profiles,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((contentSet.value.profiles) = $event)),
                  maxlength: 6
                }, {
                  suffix: _withCtx(() => [
                    _createElementVNode("div", _hoisted_44, _toDisplayString(contentSet.value.profiles.length) + "/ 6", 1)
                  ]),
                  _: 1
                }, 8, ["value"]),
                _createElementVNode("div", _hoisted_45, [
                  _createTextVNode(_toDisplayString(contentSet.value.profilesColor) + " ", 1),
                  _createVNode(_unref(ElColorPicker), {
                    modelValue: contentSet.value.profilesColor,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((contentSet.value.profilesColor) = $event)),
                    predefine: _unref(colorList),
                    size: "mini"
                  }, null, 8, ["modelValue", "predefine"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_46, [
            _hoisted_47,
            _createVNode(_component_a_switch, {
              checked: contentSet.value.btn,
              "onUpdate:checked": _cache[12] || (_cache[12] = ($event: any) => ((contentSet.value.btn) = $event))
            }, null, 8, ["checked"])
          ]),
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              _hoisted_50,
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("查看")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _createTextVNode(_toDisplayString(contentSet.value.btnColor) + " ", 1),
                  _createVNode(_unref(ElColorPicker), {
                    modelValue: contentSet.value.btnColor,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((contentSet.value.btnColor) = $event)),
                    predefine: _unref(colorList),
                    size: "mini"
                  }, null, 8, ["modelValue", "predefine"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_54, [
              _hoisted_55,
              _createElementVNode("div", _hoisted_56, [
                _createVNode(_component_a_input, {
                  placeholder: "请输入名称",
                  value: contentSet.value.btnName,
                  "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((contentSet.value.btnName) = $event)),
                  maxlength: 6
                }, {
                  suffix: _withCtx(() => [
                    _createElementVNode("div", _hoisted_57, _toDisplayString(contentSet.value.btnName.length) + "/ 6", 1)
                  ]),
                  _: 1
                }, 8, ["value"]),
                _createElementVNode("div", _hoisted_58, [
                  _createTextVNode(_toDisplayString(contentSet.value.btnNameColor) + " ", 1),
                  _createVNode(_unref(ElColorPicker), {
                    modelValue: contentSet.value.btnNameColor,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((contentSet.value.btnNameColor) = $event)),
                    predefine: _unref(colorList),
                    size: "mini"
                  }, null, 8, ["modelValue", "predefine"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_59, [
            _hoisted_60,
            _createVNode(_component_a_switch, {
              checked: contentSet.value.link,
              "onUpdate:checked": _cache[16] || (_cache[16] = ($event: any) => ((contentSet.value.link) = $event))
            }, null, 8, ["checked"])
          ]),
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("div", _hoisted_62, [
              _hoisted_63,
              _createVNode(_unref(aRadioGroup), {
                options: choiceOptions.value,
                value: contentSet.value.jump,
                "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((contentSet.value.jump) = $event))
              }, null, 8, ["options", "value"])
            ]),
            (contentSet.value.jump == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                  _hoisted_65,
                  _createVNode(_component_a_select, {
                    class: "line_select",
                    value: contentSet.value.insideLink,
                    "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((contentSet.value.insideLink) = $event)),
                    placeholder: "请选择页面",
                    options: pageOptions.value,
                    onChange: getInsideLink
                  }, null, 8, ["value", "options"])
                ]))
              : _createCommentVNode("", true),
            (contentSet.value.jump == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                  _hoisted_67,
                  _createVNode(_component_a_select, {
                    class: "line_select",
                    value: contentSet.value.inSpecificLink,
                    "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((contentSet.value.inSpecificLink) = $event)),
                    "show-search": "",
                    placeholder: "请选择内容"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sitePageLinks.value, (item) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: item,
                          value: item.id,
                          label: item.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["value", "label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]))
              : (contentSet.value.jump == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                    _hoisted_69,
                    _createVNode(_component_a_input, {
                      class: "line_select",
                      placeholder: "请输入外链",
                      value: contentSet.value.outsideLink,
                      "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((contentSet.value.outsideLink) = $event))
                    }, null, 8, ["value"])
                  ]))
                : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_70, [
            _hoisted_71,
            _createVNode(_component_a_switch, {
              checked: contentSet.value.timing,
              "onUpdate:checked": _cache[21] || (_cache[21] = ($event: any) => ((contentSet.value.timing) = $event))
            }, null, 8, ["checked"])
          ]),
          _createElementVNode("div", _hoisted_72, [
            _createElementVNode("div", _hoisted_73, [
              _hoisted_74,
              _createVNode(_component_a_date_picker, {
                "show-time": { format: 'HH:mm:ss' },
                format: "YYYY-MM-DD HH:mm:ss",
                value: contentSet.value.startTime,
                "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((contentSet.value.startTime) = $event)),
                class: "mod_range_picker",
                "disabled-date": disabledDate,
                allowClear: false
              }, {
                suffixIcon: _withCtx(() => [
                  _createVNode(_component_svg_icon, { "icon-class": "icon_time" })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_75, [
              _hoisted_76,
              _createVNode(_unref(aRadioGroup), {
                options: timeOptions.value,
                value: contentSet.value.timeChoice,
                "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((contentSet.value.timeChoice) = $event))
              }, null, 8, ["options", "value"])
            ]),
            (contentSet.value.timeChoice == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                  _hoisted_78,
                  _createVNode(_component_a_date_picker, {
                    "show-time": { format: 'HH:mm:ss' },
                    format: "YYYY-MM-DD HH:mm:ss",
                    value: contentSet.value.endTime,
                    "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((contentSet.value.endTime) = $event)),
                    class: "mod_range_picker",
                    "disabled-date": disabledDate,
                    allowClear: false
                  }, {
                    suffixIcon: _withCtx(() => [
                      _createVNode(_component_svg_icon, { "icon-class": "icon_time" })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})